import { Typography } from "@mui/material";
import React from "react";

const LabelText = ({ text = "hello" }) => {
  const p_Properties = {
    paddingBlock: "10px",
    fontSize: "12px",
    display: "flex",
    color: "rgba(47, 52, 62, 1)",
  };
  return (
    <Typography sx={p_Properties} variant="p">
      {text}
    </Typography>
  );
};

export default LabelText;
